import { ArborPage } from "./ArborPage";

const Arbor = () => {
	return <ArborPage />;
};
export default Arbor;
